import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpCancelService {
  public urlWhitelist: Array<string> = [
    '/overlaymanager/v1/overlay',
    '/monitor/MonitorManager/v1/monitorsDetailedInfo',
    '/agent/v1/agentDetailedInfo',
    'analytics/entity/v1/summary/monitors',
    '/notification/v1/operations/preferences/webui',
    '/notification/v1/operations/motd/'
  ];

  private readonly cancelPendingRequests$: Subject<void> = new Subject<void>();

  public cancelable(url: string): boolean {
    return this.urlWhitelist.indexOf(url) === -1;
  }

  /** Cancels all pending Http requests. */
  public cancelPendingRequests(): void {
    this.cancelPendingRequests$.next();
  }

  public onCancelPendingRequests(): Observable<void> {
    return this.cancelPendingRequests$.asObservable();
  }
}
